import clsx from 'clsx';
import React from 'react';

const TabLink = ({ selected, children }) => {
  return (
    <div
      className={clsx(
        `relative group border-b-2 border-transparent transition-[background-color]  ease-out focus:outline-none focus:border-foreground ring-0 font-medium hover:text-foreground -m-2 p-2 rounded-md hover:bg-gray-50 dark:hover:bg-muted text-left text-sm`,
        {
          '!text-foreground !border-foreground rounded-b-none': selected,
        },
      )}
    >
      {children}
    </div>
  );
};

export default TabLink;
